import { createMask, MaskedRange } from 'imask';

/**
 * Mascara para números de telefone
 *
  @example
    const phone = maskPhone.resolve('00987654321')
    phone === '(00) 9 8765-4321'

  @returns {string} string no formato (00) 9 0000-0000
 *
 */
export const maskLocalPhone = createMask({ mask: '(00) 0000-0000' });
/**
 * Mascara para números de telefone
 *
  @example
    const phone = maskPhone.resolve('00987654321')
    phone === '(00) 9 8765-4321'

  @returns {string} string no formato (00) 9 0000-0000
 *
 */
export const maskPhone = createMask({ mask: '(00) 0 0000-0000' });
/**
 * Remove mascara dos números de telefone
 *
  @example
    const phone = unmaskPhone.resolve('(00) 9 8765-4321')
    phone === '00987654321'

  @returns {string} string no formato 00000000000
 *
 */
export const unmaskPhone = createMask({ mask: '00000000000' });
/**
 * Oculta parcialmente os números de telefone
 *
  @example
    const phone = unmaskPhone.resolve('00987654321')
    phone === '(00) 9 ••••-4321'

  @returns {string} string no formato '(00) 9 ••••-4321'
 *
 */
export const hidePhone = createMask({ mask: '(00) 0 ••••-0000' });

/**
 * Mascara para cpf
 *
  @example
    const cpf = maskCpf.resolve('00000000000')
    cpf === '000.000.000-00'

  @returns {string} string no formato 000.000.000-00
 *
 */
export const maskCpf = createMask({ mask: '000.000.000-00' });
/**
 * Remove mascara de cpf
 *
  @example
    const cpf = unmaskCpf.resolve('000.000.000-00')
    cpf === '00000000000'

  @returns {string} string no formato 00000000000
 *
 */
export const unmaskCpf = createMask({ mask: '00000000000' });

/**
 * Mascara para cnpj
 *
  @example
    const cnpj = maskCnpj.resolve('00000000000000')
    cnpj === '00.000.000/0000-00'

  @returns {string} string no formato 00.000.000/0000-00
 *
 */
export const maskCnpj = createMask({ mask: '00.000.000/0000-00' });
/**
* Remove mascara de cpf
*
 @example
   const cpf = unmaskCnpj.resolve('00.000.000/0000-00')
   cpf === '00000000000000'

 @returns {string} string no formato 00000000000000
*
*/
export const unmaskCnpj = createMask({ mask: '00000000000000' });

/**
* Mascara para datas
* somente suporta dias entre 1 - 31
* somente suporta meses entre 1 - 12
* somente suporta abos entre 1900 - 2030
*
 @example
   const date = unmaskCnpj.resolve('00000000')
   date === '00/00/0000'

 @returns {string} string no formato 00/00/0000
*
*/
export const maskDate = createMask({
  blocks: {
    YYYY: {
      mask: MaskedRange,
      from: 1500,
      to: 2050,
    },
    MM: {
      mask: MaskedRange,
      from: 1,
      to: 12,
    },
    DD: {
      mask: MaskedRange,
      from: 1,
      to: 31,
    },
  },
  mask: 'DD/MM/YYYY',
});

/**
* Mascara para tempo
* suporta horas entre 0 - 23
* suporta minutos entre 0 - 59
*
 @example
   const time = maskTime.resolve('1234')
   time === '12:34'

 @returns {string} string no formato 00:00
*
*/
export const maskTime = createMask({
  blocks: {
    HH: {
      mask: MaskedRange,
      from: 0,
      to: 23,
    },
    MIN: {
      mask: MaskedRange,
      from: 0,
      to: 59,
    },
  },
  mask: 'HH:MIN',
});

export const maskMoney = createMask({
  blocks: {
    num: {
      mask: Number,
      thousandsSeparator: '.',
    },
  },
  mask: 'R$ num',
});

export const maskKm = createMask({
  blocks: {
    num: {
      mask: Number,
    },
  },
  mask: 'num Km',
});

export const maskLicensePlate = createMask({ mask: '***-****' });

export default {
  maskCnpj,
  maskCpf,
  maskDate,
  maskKm,
  maskMoney,
  maskLocalPhone,
  maskPhone,
  maskTime,
  unmaskCnpj,
  unmaskCpf,
  unmaskPhone,
  maskLicensePlate,
};
